<template>
  <div>
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide>
        <div class="swiper">
          <div class="pic">
            <img
              src="/static/img/p23-1.jpg"
              width="100%"
              alt="蓝鲨 Robor 防水防尘"
            />
          </div>
          <div class="text t23">
            <div class="fs_big1 aniel" :class="{ ani: a1 }">
              中控屏幕风雨不入
            </div>
          </div>
          <div class="text t23a">
            <div class="fs_content t23a_1">IPX5</div>
            <div class="fs_tiny color_gray">防水等级</div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swiper">
          <div class="pic">
            <img
              src="/static/img/p23-2.jpg"
              width="100%"
              alt="蓝鲨 Robor 水位感应"
            />
          </div>
          <div class="text fs_big1 t23">水位感应驭浪而行</div>
          <div class="text t23a">
            <div class="fs_content t23a_1">
              252 <span class="fs_tiny color_gray">mm</span>
            </div>
            <div class="fs_tiny color_gray">涉水深度</div>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      a1: false,
      swiperOption: {
        loop: false,
        resistanceRatio: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    startani() {
      this.a1 = true
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/swiper.less';
.swiper-pagination {
  bottom: 5vw !important;
}
.t23 {
  top: 4vw;
  text-align: center;
  width: 100%;
}
.t23a {
  bottom: 8vw;
  text-align: center;
  width: 100%;
  .t23a_1 {
    margin-bottom: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/swiper/swiper23.vue